export const retryFunctions: Record<string, () => void> = {};
